import React from 'react';
import { Flex, Title, Text } from '@mantine/core';
import { formatDateOnly } from 'utils/dateUtils';
import { DateTime } from 'luxon';

interface ModalDateBadgeProps {
  title: string;
  date: DateTime;
  accessorKey: string;
}

export const ModalDateBadge: React.FC<ModalDateBadgeProps> = ({
  title,
  date,
  accessorKey,
}) => {
  return (
    <React.Fragment key={accessorKey}>
      <Flex
        align={'center'}
        gap={'md'}
        style={{ paddingBottom: '2%' }}
        direction={'column'}
      >
        <Title order={6}>{title}</Title>
        <Text variant="outline" size="lg">
          {formatDateOnly(date)}
        </Text>
      </Flex>
    </React.Fragment>
  );
};
